<div class="banner-with-tab-group container-v2">
  <sd-swiper [items]="bannersGroup" [config]="config">
    <ng-template let-item="item">
      <div
        class="banner-with-tab-group-item text-b3-s-300 text-md-b2-s-300 text-lg-b1-s-300"
        [class.active]="isSelectedGroup(item.label)"
        (click)="onSelect(item.label)"
      >
        {{ item.label }}
      </div>
    </ng-template>
  </sd-swiper>
</div>
